import { GET_STRUCT_TREE } from "../../../enums/Request/leader.requests.types";

export const getStructureTreeAction = (tree) => {
    return {
        type: GET_STRUCT_TREE,
        payload: tree,
    };
};